import React from "react"
import FooterColumn from "../FooterColumn"
import FooterLink from "../FooterLink"
import { Query } from "react-apollo"
import gql from "graphql-tag"

const GET_POSITIONS = gql`
  {
    availablePositions @client {
      title
      path
    }
  }
`

const AvailablePositions = () => (
  <Query query={GET_POSITIONS}>
    {({ data: { availablePositions } }) => (
      <FooterColumn title="Lediga tjänster">
        {availablePositions.map(position => (
          <FooterLink
            key={position.title}
            text={position.title}
            to={position.path}
          />
        ))}
      </FooterColumn>
    )}
  </Query>
)

export default AvailablePositions



// WEBPACK FOOTER //
// ./src/components/Footer/AvailablePositions/index.jsx